const PaymentMethods = {
    BankBillet: 1,
    BankTransfer: 2,
    Darf: 3
};

export default PaymentMethods;
